export const RQ_GET_LAST_WORKING_DAY_API = {
  url:'reports/web/effort/last-working-day/<%= employeeCode %>',
  method: 'GET',
  auth: true,
};
